export default __webpack_public_path__ + "static/landscapes-third-24294be5fd9970b808733e011702808a.webp";